import React from 'react'
import { ChevronIcon } from '@sainsburys-tech/bolt-icons'
import { Drawer } from '@sainsburys-tech/bolt'
import { C002DrawerProps } from './types'
import { isEmpty, agnostifyUrl } from '../../../helpers/utils'
import Image from '../../../helpers/Image/Image'
import {
  StyledDrawerImageContainer,
  StyledChevronContainer,
  StyledChevronButton,
  StyledDrawerHeadingContainer,
  StyledDateLabel,
  StyledDescriptionContainer
} from './C002Drawer.styles'

import { StyledCTALink, StyledInstagramIcon } from './C002.styles'

const C002StorystreamDrawer = ({
  displayImage,
  toggleCallback,
  carouselCallback
}: C002DrawerProps): React.ReactElement => {
  if (!displayImage) return null

  const drawerHeading =
    !displayImage?.author && !displayImage?.socialMediaUrl ? (
      ''
    ) : (
      <>
        <StyledDrawerHeadingContainer
          href={displayImage?.socialMediaUrl ? displayImage.socialMediaUrl : undefined}
          target='_blank'
          as={displayImage?.socialMediaUrl ? 'a' : undefined}
        >
          {displayImage.author && <span data-test='c002-drawer-author'>{displayImage.author}</span>}
          {displayImage.socialMediaUrl && <StyledInstagramIcon data-test='instagram-icon' />}
        </StyledDrawerHeadingContainer>
      </>
    )

  return (
    <Drawer
      data-test='c002-drawer'
      heading={drawerHeading}
      show={!isEmpty(displayImage)}
      size='md'
      onClose={toggleCallback}
    >
      <StyledDrawerImageContainer aria-live='polite' isSainsburys>
        <StyledChevronContainer dir='left' isSainsburys>
          <StyledChevronButton onClick={() => carouselCallback(displayImage?.index, 'previous')}>
            <ChevronIcon aria-label='Previous image' data-test='chevron-left' dir='left' width='2em' height='2em' />
          </StyledChevronButton>
        </StyledChevronContainer>
        <Image
          data-test={`c002-drawer-main-image-${displayImage?.index}`}
          src={displayImage?.urlLarge}
          alt={`Image by @${displayImage?.author}`}
          smart
        />
        <StyledChevronContainer isSainsburys>
          <StyledChevronButton onClick={() => carouselCallback(displayImage.index, 'next')}>
            <ChevronIcon aria-label='Next image' data-test='chevron-right' dir='right' width='2em' height='2em' />
          </StyledChevronButton>
        </StyledChevronContainer>
        {displayImage?.nonPDPs[0] && (
          <StyledCTALink
            data-test='c002-drawer-cta-link'
            title={displayImage.buttonText}
            kind='primary'
            full
            onClick={() => window.open(agnostifyUrl(displayImage.nonPDPs[0]), '_blank')}
          >
            {displayImage?.buttonText}
          </StyledCTALink>
        )}
      </StyledDrawerImageContainer>
      <StyledDateLabel data-test='c002-drawer-date'>{displayImage?.timestamp}</StyledDateLabel>
      <StyledDescriptionContainer data-test='c002-drawer-description'>
        {displayImage?.description && <p>{displayImage.description}</p>}
      </StyledDescriptionContainer>
    </Drawer>
  )
}

export default C002StorystreamDrawer
